
// 获取问卷题目类型
export const getQuestionType = (item) => {
  if(!item)return
  let subjectType=item.subjectType||''//题型
  let subjectItemType=item.subjectItemType||''//题型分类
  let interactType=item.interactType||''//交互方式
  switch (true) {
    case subjectType === '单选题' && (subjectItemType === '1' || subjectItemType === '4') && interactType === '1':
      return 1;
    case subjectType === '多选题' && (subjectItemType === '1' || subjectItemType === '4') && interactType === '1':
      return 2;
    case subjectType === '单行填空题':
      return 3;
    case subjectType === '多行填空题':
      return 4;
    case subjectType === '选择区域':
      return 5;
    case subjectType === '调研对象':
      return 6;
    case subjectType === '客户名称':
      return 7;
    case subjectType.indexOf('上传照片') > -1:
      return 8;
    default:
      return 0;
  }
  
}
  
  
